import ky from 'ky';

let userData = localStorage.getItem('admintoken') ? localStorage.getItem('admintoken') : "";
class HTTPError extends Error { }
const clientAuth = ky.extend({
  // prefixUrl: "https://api.borntocamp.de/api/admin/",
  // prefixUrl: "http://localhost/camper-api/public/api/admin/",
  prefixUrl: "https://camperapi.rigicgspl.com/public/api/admin/",
  // prefixUrl: "https://devapi.borntocamp.de/api/admin/",
  timeout:false,
  hooks: {
    beforeRequest: [
      (options) => {
        const localHeaders = JSON.parse(localStorage.getItem('admintoken'));
        if (localHeaders) {
          options.headers.set('Authorization', `Bearer ${localHeaders}`);
        }
      },
    ],
    afterResponse: [
      async (response) => {
        if (response.status === 401) {

          const body = await response.json()
          throw new HTTPError(body.message);
        }
      }
    ]
  },
  // headers: { 'Authorization': `Bearer ${userData}` }
});

export default clientAuth;